<template>
    <main>
        <div>
            <v-dialog v-model="modaltutorialwrited" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="#007bff"  fixed
                    >
                    <v-btn icon dark @click="closemodaltutorialwrited">
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                    <v-toolbar-title v-if="tabguide[0].selected">{{language==='English'?'Publish your projects':'Publica tus proyectos'}}</v-toolbar-title>
                    <v-toolbar-title v-if="tabguide[1].selected">{{language==='English'?'Upload your files':'Sube tus archivos'}}</v-toolbar-title>
                    <v-toolbar-title v-if="tabguide[2].selected">{{language==='English'?'Contact HiChat service':'Comunicate con el servicio de HiChat'}}</v-toolbar-title>
                    <v-toolbar-title v-if="tabguide[3].selected">{{language==='English'?'Publications':'Publicaciones'}}</v-toolbar-title>
                    <v-toolbar-title v-if="tabguide[4].selected">{{language==='English'?'Recieve Feedback':'Recibe Feedback'}}</v-toolbar-title>
                    <v-toolbar-title v-if="tabguide[5].selected">{{language==='English'?'Search Projects':'Busca Proyectos'}}</v-toolbar-title>
                    <v-toolbar-title v-if="tabguide[6].selected">{{language==='English'?'Search Profesionals':'Busca Profesionales'}}</v-toolbar-title>
                    <v-toolbar-title v-if="tabguide[7].selected">{{language==='English'?'Sign up':'Registrate'}}</v-toolbar-title>
                    <!--v-spacer></v-spacer>
                    <v-btn icon dark @click="modaltutorialwrited=false;opentutorialvideo()">
                        <v-icon>far fa-file-video</v-icon>
                    </v-btn-->

                </v-toolbar>
                <v-list class="div-list" style="padding-top:80px; padding-bottom:150px">
                    <div class="row justify-center" v-if="tabguide[0].selected">
                        <div class="col-11" style="text-align:center">
                            <p style="font-size:25px">{{language==='English'?'Publish your ':'Publica tus '}}<label style="font-weight:bold">{{language==='English'?'Projects ':'Proyectos '}}</label>{{language==='English'?' and create your ':' y crea tu '}}
                            <label style="font-weight:bold">{{language==='English'?'Profesional Portfolio':'Portafolio Profesional'}}</label></p>
                        </div>
                        <div class="col-11">
                            <div class="containerimg">
                                <img src="/img/paper-3033204_640.jpg" width="960" height="640"/>
                            </div>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn @click="goLogin">
                                {{language==='English'?'Log in':'Iniciar Sesión'}}
                            </v-btn>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn color="primary" @click="goRegister">
                                {{language==='English'?'Sign in':'Registrese'}}
                            </v-btn>
                        </div>
                    </div>
                    <div class="row justify-center" v-if="tabguide[1].selected">
                        <div class="col-11" style="text-align:center">
                            <p style="font-size:25px">{{language==='English'?'Upload your ':'Sube tus '}}<label style="font-weight:bold">{{language==='English'?'Files ':'Archivos '}}</label>{{language==='English'?' for each ':' por cada '}}
                            <label style="font-weight:bold">{{language==='English'?'Project':'Proyecto'}}</label></p>
                        </div>
                        <div class="col-11">
                            <div class="containerimg">
                                <img src="/img/technology-2082642_1280.jpg" width="960" height="640"/>
                            </div>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn @click="goLogin">
                                {{language==='English'?'Log in':'Iniciar Sesión'}}
                            </v-btn>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn color="primary" @click="goRegister">
                                {{language==='English'?'Sign in':'Registrese'}}
                            </v-btn>
                        </div>
                    </div>
                    <div class="row justify-center" v-if="tabguide[2].selected">
                        <div class="col-11" style="text-align:center">
                            <p style="font-size:25px">{{language==='English'?'Communicate with other professionals in  ':'Comunicate con otros profesionales en '}}<label style="font-weight:bold">{{language==='English'?' Chat ':' Chat '}}</label>{{language==='English'?' also with your followers and users that you are following.':' tambien con tus seguidores y usuarios que estas siguiendo'}}</p>                        
                        </div>
                        <div class="col-11">
                            <div class="containerimg">
                                <img src="/img/man-2814937_640.jpg" width="960" height="640"/>
                            </div>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn @click="goLogin">
                                {{language==='English'?'Log in':'Iniciar Sesión'}}
                            </v-btn>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn color="primary" @click="goRegister">
                                {{language==='English'?'Sign in':'Registrese'}}
                            </v-btn>
                        </div>
                    </div>
                    <div class="row justify-center" v-if="tabguide[3].selected">
                        <div class="col-11" style="text-align:center">
                            <p style="font-size:25px">{{language==='English'?'Write recommendations, tips to your  ':'Escribe recomendaciones, tips a tus '}}<label style="font-weight:bold">{{language==='English'?' followers ':' seguidores '}}</label>{{language==='English'?' by making posts.':' haciendo publicaciones.'}}</p>                        
                        </div>
                        <div class="col-11">
                            <div class="containerimg">
                                <img src="/img/post-it-4129907_640.jpg" width="960" height="640"/>
                            </div>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn @click="goLogin">
                                {{language==='English'?'Log in':'Iniciar Sesión'}}
                            </v-btn>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn color="primary" @click="goRegister">
                                {{language==='English'?'Sign in':'Registrese'}}
                            </v-btn>
                        </div>
                    </div>
                    <div class="row justify-center" v-if="tabguide[4].selected">
                        <div class="col-11" style="text-align:center">
                            <p style="font-size:25px">{{language==='English'?'Recieve comments for each ':'Recibe comentarios de cada '}}<label style="font-weight:bold">{{language==='English'?' Project ':'Proyecto '}}</label>{{language==='English'?' getting ':' obteniendo '}}
                            <label style="font-weight:bold">{{language==='English'?' Feedback ':' Feedback '}}</label>{{language==='English'?' and creating your ':' y creando tu '}}<label style="font-weight:bold">{{language==='English'?' Comunity':' Comunidad'}}</label></p>
                        </div>
                        <div class="col-11">
                            <div class="containerimg">
                                <img src="/img/fax-1889009_640.jpg" width="960" height="640"/>
                            </div>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn @click="goLogin">
                                {{language==='English'?'Log in':'Iniciar Sesión'}}
                            </v-btn>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn color="primary" @click="goRegister">
                                {{language==='English'?'Sign in':'Registrese'}}
                            </v-btn>
                        </div>
                    </div>
                    <div class="row justify-center" v-if="tabguide[5].selected">
                        <div class="col-11" style="text-align:center">
                            <p style="font-size:25px">{{language==='English'?'Search ':'Busca '}}<label style="font-weight:bold">{{language==='English'?' Projects ':'Proyectos '}}</label>{{language==='English'?' rate them with ':' calificalos con '}}
                            <label style="font-weight:bold">{{language==='English'?' Stars ':' Estrellas '}}</label>{{language==='English'?' and comment his ':' y comenta sobre su '}}<label style="font-weight:bold">{{language==='English'?' Project':' Proyecto'}}</label></p>
                        </div>
                        <div class="col-11">
                            <div class="containerimg">
                                <img src="/img/search-2876776_640.jpg" width="960" height="640"/>
                            </div>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn @click="goLogin">
                                {{language==='English'?'Log in':'Iniciar Sesión'}}
                            </v-btn>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn color="primary" @click="goRegister">
                                {{language==='English'?'Sign in':'Registrese'}}
                            </v-btn>
                        </div>
                    </div>
                    <div class="row justify-center" v-if="tabguide[6].selected">
                        <div class="col-11" style="text-align:center">
                            <p style="font-size:25px">{{language==='English'?'Search other':'Busca otros '}}<label style="font-weight:bold">{{language==='English'?' Profesionals ':'Profesionales '}}</label>{{language==='English'?' to know about them.':' para saber de ellos.'}}</p>
                        </div>
                        <div class="col-11">
                            <div class="containerimg">
                                <img src="/img/magnifier-1787362_640.png" width="960" height="640"/>
                            </div>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn @click="goLogin">
                                {{language==='English'?'Log in':'Iniciar Sesión'}}
                            </v-btn>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn color="primary" @click="goRegister">
                                {{language==='English'?'Sign in':'Registrese'}}
                            </v-btn>
                        </div>
                    </div>
                    <div class="row justify-center" v-if="tabguide[7].selected">
                        <div class="col-11" style="text-align:center">
                            <p style="font-size:25px">{{language==='English'?'It´s very to begin! only':'¡Es muy fácil de comenzar! tan solo '}}<label style="font-weight:bold">{{language==='English'?' Sign up ':'Registrate '}}</label>{{language==='English'?' and ready.':' y listo.'}}</p>
                        </div>
                        <div class="col-11">
                            <div class="containerimg">
                                <img src="/img/computer-1331579_640.png"/>
                            </div>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn @click="goLogin">
                                {{language==='English'?'Log in':'Iniciar Sesión'}}
                            </v-btn>
                        </div>
                        <div class="col-11" style="text-align:center">
                            <v-btn color="primary" @click="goRegister">
                                {{language==='English'?'Sign in':'Registrese'}}
                            </v-btn>
                        </div>
                    </div>
                    
                </v-list>
                 <v-footer
                    fixed style="margin-bottom:17px"
                >
                    <v-toolbar
                    >
                        <v-btn v-if="!tabguide[7].selected" icon dark @click="selectforwardtypeguide">
                            <v-icon color="black" style="font-size:20px">fas fa-chevron-right</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <label v-if="tabguide[0].selected">{{language==='English'?'1 of 8':'1 de 8'}}</label>
                        <label v-if="tabguide[1].selected">{{language==='English'?'2 of 8':'2 de 8'}}</label>
                        <label v-if="tabguide[2].selected">{{language==='English'?'3 of 8':'3 de 8'}}</label>
                        <label v-if="tabguide[3].selected">{{language==='English'?'4 of 8':'4 de 8'}}</label>
                        <label v-if="tabguide[4].selected">{{language==='English'?'5 of 8':'5 de 8'}}</label>
                        <label v-if="tabguide[5].selected">{{language==='English'?'6 of 8':'6 de 8'}}</label>
                        <label v-if="tabguide[6].selected">{{language==='English'?'7 of 8':'7 de 8'}}</label>
                        <label v-if="tabguide[7].selected">{{language==='English'?'8 of 8':'8 de 8'}}</label>
                        <v-spacer></v-spacer>
                        <v-btn v-if="!tabguide[0].selected" icon dark @click="selectbackwardtypeguide">
                            <v-icon color="black" style="font-size:20px">fas fa-chevron-left</v-icon>
                        </v-btn>
                    </v-toolbar>
                 </v-footer> 

            </v-card>
            </v-dialog>
        </div>
        <v-layout>
            <v-dialog max-width="1000" max-height="100%" v-model="modaltutorial" persistent>
                <button type="button" class="close" @click="closemodaltutorial">
                    <span style="color:black;font-size:30px" aria-hidden="true">&times;</span>
                </button>
                <v-container style="background:white" grid-list-xs text-xs-center>
                    <div class="text-center" style="margin-bottom:10px">
                        <h2>Tutorial</h2>
                    </div>
                    <div class="text-center">
                        <button class="btn btn-primary" style="margin-bottom:30px" type="submit" @click="modaltutorial=false;modaltutorialwrited=true">{{language==='English'?'Tutorial writed':'Tutorial Escrito'}}</button>
                    </div>

                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/zVQD3GhawHM" allowfullscreen></iframe>
                    </div>
                </v-container>
            </v-dialog>
        </v-layout>
    </main>
</template>
<script>
import { EventBus } from '../../../helpers/eventbus/event-bus';
export default {
    data(){
        return{
            language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
            modaltutorial: false,
            modaltutorialwrited:false,
            tabguide:[
                {id:'1', name:'createproject', selected:true},
                {id:'2', name:'fileupload', selected:false},
                {id:'3', name:'Hichat', selected:false},
                {id:'4', name:'extraproject', selected:false},
                {id:'5', name:'editprofile', selected:false},
                {id:'6', name:'comments', selected:false},
                {id:'7', name:'comments', selected:false},
                {id:'8', name:'comments', selected:false},
            ]
        }
    },
    mounted(){
        EventBus.$on('opentutorial',()=>{
            this.modaltutorial = true
        })
         EventBus.$on('opentutorialwrited',()=>{
            this.modaltutorialwrited=true
        })
    },

    methods:{
        goLogin(){
            EventBus.$emit('goLogin')
        },
        goRegister(){
            EventBus.$emit('goRegister')
        },
        opentutorialvideo(){
            this.modaltutorial = true
        },
        isTabActive:function(index){
            //console.log(index);
            this.tabguide.forEach(element=>{
                element.selected=false
            })
            this.tabguide[index].selected=true
        },
        selectforwardtypeguide(){
            if(this.tabguide[0].selected === true){
                this.isTabActive(1)
            }else if(this.tabguide[1].selected === true){
                this.isTabActive(2)
            }else if(this.tabguide[2].selected === true){
                this.isTabActive(3)
            }else if(this.tabguide[3].selected === true){
                this.isTabActive(4)
            }else if(this.tabguide[4].selected === true){
                this.isTabActive(5)
            }else if(this.tabguide[5].selected === true){
                this.isTabActive(6)
            }else{
                 this.isTabActive(7)
            }
        },
        selectbackwardtypeguide(){
            if(this.tabguide[1].selected === true){
                this.isTabActive(0)
            }else if(this.tabguide[2].selected === true){
                this.isTabActive(1)
            }else if(this.tabguide[3].selected === true){
                this.isTabActive(2)
            }else if(this.tabguide[4].selected === true){
                this.isTabActive(3)
            }else if(this.tabguide[5].selected === true){
                this.isTabActive(4)
            }else if(this.tabguide[6].selected === true){
                this.isTabActive(5)
            }else{
                this.isTabActive(6)
            }
        },
        closemodaltutorialwrited(){
            this.modaltutorialwrited = false
            let getdatauser = JSON.parse(localStorage.getItem('iden'))
            if(getdatauser){
                let isnewuser = getdatauser.statususer === 'newuser'
                if(isnewuser){
                    getdatauser.statususer = 'olduser'
                    localStorage.setItem('iden',JSON.stringify(getdatauser))
                }
            }
        },
        closemodaltutorial(){
            this.modaltutorial = false
            let getdatauser = JSON.parse(localStorage.getItem('iden'))
            if(getdatauser){
                let isnewuser = getdatauser.statususer === 'newuser'
                if(isnewuser){
                    getdatauser.statususer = 'olduser'
                    localStorage.setItem('iden',JSON.stringify(getdatauser))
                }
            }
        }
    }
}
</script>
<style scoped>
    .containerimg {
        text-align: center;
        width: 96%;
        max-width: 960px;
        margin: 0 auto;
    }
    .containerimg img {
        width: 60%;
        height: 400px;
    }
    @media (max-width: 767px) {
        .containerimg img {
             width: 80%;
            height: 200px;
        }
    }
    .filters{
        padding-left: 35px;
    }
    .filters ul{
        padding-left:0;margin-bottom:30px
    }
    @media (max-width: 767px) {
        .div-list {
            overflow:auto
        }
    }
    @media (max-width: 991px){
        .filters ul{
            margin-bottom:20px
        }
    }
    .filters ul li{
        display:inline-block;
        margin-right:40px;font-size:13px;
        font-weight:400;text-transform:uppercase;
        color:#05364d;cursor:pointer;
        -webkit-transition:all 0.4s ease 0s;
        -moz-transition:all 0.4s ease 0s;
        -o-transition:all 0.4s ease 0s;transition:all 0.4s ease 0s
    }
    .filters ul li:hover,.filters ul li.active{
        color:#1345e6
    }
   

</style>